var value;
import api from './api';
export default function(obj,fun){
  value=null;
  console.log(value,'value');
    obj.$Modal.confirm({
        render: h => {
          return h("Input", {
            style: {
              paddingLeft: "40px",
            },
            props: {
              icon: "md-lock",
              type: 'password',
              autofocus: true,
              placeholder: "请输入操作密码..."
            },
            on: {
              input: val => {
                value = val;
              }
            }
          });
        },
        title: "操作密码",
        cancelText: "忘记密码？",
        onOk: () => {
          if(!value){
            this.$Message.error('密码不能为空');
            return;
          }
          api
          .post("/developers/user/keys", {keys:value})
          .then(res => {
            if (res.code == 200) {
              fun();
            } else {
              this.$Message.warning("密码错误");
            }
          });
        },
        onCancel: () => {
            obj.$router.push('/my');
        }
      });
}


// WEBPACK FOOTER //
// ./src/cipher.js